export default "__VITE_ASSET__kbwJYaMg__"